import { render, staticRenderFns } from "./WoundWheel.vue?vue&type=template&id=c2eeeeda&"
import script from "./WoundWheel.vue?vue&type=script&lang=js&"
export * from "./WoundWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports